<main id="main">
    <!-- ======= Breadcrumbs ======= -->
    <div class="breadcrumbs" data-aos="fade-in">
        <div class="container">
            <h2 >Copyrights</h2>
        </div>
    </div><!-- End Breadcrumbs -->

    <section id="testimonials1">
        <div class="container" data-aos="fade-up">

            <!-- <div class="section-title pb-0">
                <h2>Read Online</h2>
                <p  >Copyrights</p><br>
            </div> -->
            <div class="row">
                <div class="col">
                <p>
                    This website and its content is copyright of www.sarvadhnya.com - © sarvadhnya.com. 
                
                All rights reserved.</p><p>
                
                Any redistribution or reproduction of part or all of the contents in any form is prohibited 
                
                other than the following:</p><p>
                
                you may print or download to a local hard disk extracts for your personal and non-
                
                commercial use only</p><p>
                </p><p>you may copy the content to individual third parties for their personal use, but only if 
                
                you acknowledge the website as the source of the material</p><p>
                You may not, except with our express written permission, distribute or commercially exploit 
                
                the content. Nor may you transmit it or store it in any other website or other form of 
                
                electronic retrieval system.</p>
                
                </div>
            </div>

        </div>
    </section>
</main>